module.exports = __webpack_public_path__ + "static/assets/8e27ca9b97818a169be94795a48d8bad.gif";